import React from 'react';
import { FormattedMessage } from 'react-intl';

export class SignUpTitle extends React.Component<{}> {
  render() {
    return (
      <>
        <div className="signup-form__title">
          <FormattedMessage id="signup/routes/user/form/SignUpTitle.tsx/1" />
          <br />
          <FormattedMessage id="signup/routes/user/form/SignUpTitle.tsx/2" />
        </div>
        <div className="signup-form__subtitle">
          <span className="hide_on--tablet">
            <FormattedMessage id="signup/routes/user/form/SignUpTitle.tsx/3" />{' '}
          </span>
          <FormattedMessage id="signup/routes/user/form/SignUpTitle.tsx/4" />
          <br />
          <FormattedMessage id="signup/routes/user/form/SignUpTitle.tsx/5" />
        </div>
      </>
    );
  }
}
